var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { JobRole } from '../../../../enums/workload/job-role';
import { EnumUtil } from '../../../../enums/enum-util';
import { StaffService } from '../../../../services/workload/staff.service';
import { EmailValidator } from '../../../../logic/email/email-validator';
var CreateUserComponent = /** @class */ (function () {
    function CreateUserComponent(staffService, toastr) {
        this.staffService = staffService;
        this.toastr = toastr;
        this.userCreated = new EventEmitter();
        this.selectedRole = JobRole.TeamMember;
        this.createUserSubscription = new Subscription();
        this.defaultStaff = {
            id: 0,
            forename: '',
            surname: '',
            emailAddress: '',
            role: JobRole.TeamMember,
            teamId: 0,
            staffName: ''
        };
        this.viewModel = {
            user: this.defaultStaff,
            labels: {
                forename: 'Name',
                surname: 'Surname',
                email: 'Email',
                role: 'Role'
            },
            roles: EnumUtil.toArray(JobRole).map(function (x) { return x.id; }).reverse(),
            createButtonText: 'CREATE',
            createButtonTitleText: 'Create User'
        };
        this.teamId = Input('teamId');
    }
    CreateUserComponent.prototype.ngOnDestroy = function () {
        if (this.createUserSubscription)
            this.createUserSubscription.unsubscribe();
    };
    CreateUserComponent.prototype.roleSelected = function (role) {
        this.selectedRole = role;
    };
    CreateUserComponent.prototype.isFormValid = function () {
        var isValid = false;
        if (this.viewModel.user.forename.trim()
            && this.viewModel.user.surname.trim()
            && EmailValidator.validate(this.viewModel.user.emailAddress))
            isValid = true;
        return isValid;
    };
    CreateUserComponent.prototype.createUser = function () {
        var _this = this;
        var staff = this.viewModel.user;
        staff.role = this.selectedRole;
        staff.teamId = this.teamId;
        this.createUserSubscription = this.staffService.createStaff(staff).subscribe(function (result) {
            result.teamId = _this.teamId;
            _this.userCreated.emit(result);
            _this.toastr.success(staff.forename + " " + staff.surname + " has been added", 'Success!', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        }, function (error) {
            _this.toastr.error(staff.emailAddress + " cannot be used.", 'Error!', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], CreateUserComponent.prototype, "teamId", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], CreateUserComponent.prototype, "userCreated", void 0);
    CreateUserComponent = __decorate([
        Component({
            selector: 'create-user',
            template: require('./create-user.component.html'),
            styles: [require('./create-user.component.scss')]
        }),
        __metadata("design:paramtypes", [StaffService,
            ToastrService])
    ], CreateUserComponent);
    return CreateUserComponent;
}());
export { CreateUserComponent };
//# sourceMappingURL=data:application/json;base64,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